module.exports = __webpack_public_path__ + "files/d5137df5a5b15bafa42fdb76823a2505.svg";